<template>
  <div class="v-subscription-create-update-form">
    <div class="modal-backdrop">
      <div class="modal">

        <header class="modal-header">
          <slot name="header">
            <h5 v-if="this.subscriptionId">Редактировать информацию о подписке</h5>
            <h5 v-else>Добавить новую подписку</h5>
            <button type="button" class="btn-close" @click="close">x</button>
          </slot>
        </header>

        <section class="modal-body mx-3">
          <slot name="body">
            <div v-if="this.loading">
              <div class="d-flex justify-content-center">
                <div class="spinner-grow m-5" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </div>
            <form v-else class="form" @submit.prevent="createUpdateSubscription"
                  autocomplete="nope">
              <div class="row pt-3">
                <div class="col-lg-6">
                  <div v-if="!this.subscriptionId">
                     <multiselect
                        v-model="inputs.sim_card"
                        :options="simCardList"
                        track-by="serial_number"
                        label="phone_number"
                        placeholder="Выберите SIM карту"
                        @input="gerDealerTariffs"
                        :allow-empty="false">
                        <template slot="singleLabel" slot-scope="{ option }">
                          {{ option.phone_number }}
                        </template>
                      </multiselect>
                  </div>
                  <div v-else><h6>SIM карта: {{ inputs.sim_card }}</h6></div>
                </div>
                <div class="col-lg-6">
                  <div v-if="!this.subscriptionId">
                    <multiselect
                      v-model="inputs.subscriber"
                      :options="userList"
                      track-by="id"
                      :custom-label="fullName"
                      placeholder="Выберите пользователя"
                      deselect-label="Can't remove this value"
                      :allow-empty="false">
                      <template slot="singleLabel" slot-scope="{ option }">
                        {{ option.last_name }} {{ option.first_name }} {{ option.middle_name }}
                      </template>
                    </multiselect>
                  </div>
                  <div v-else><h6>Подписчик: {{ inputs.subscriber }}</h6></div>
                </div>
              </div>
              <div class="row pt-4">
                <div class="col-6">
                  <textarea name="comment" rows="8" class="p-3"
                            v-model="inputs.internal_comment"
                            placeholder='Комментарий к подписке'>
                  </textarea>
                </div>
                <div class="col-6">
                  <div class="row">
                    <div class="col-12 pb-3">
                      <multiselect
                        v-model="inputs.tariff"
                        :options="tariffList"
                        track-by="id"
                        label="name"
                        placeholder="Выберите тариф"
                        @input="initialPaymentCount()"
                        :allow-empty="false">
                        <template slot="singleLabel" slot-scope="{ option }">
                          {{ option.name }}
                        </template>
                      </multiselect>
                    </div>
                    <div class="col-12 pb-3">
                      <multiselect
                        v-model="status"
                        :options="statusList"
                        track-by="filter"
                        label="name"
                        selectLabel=""
                        deselectLabel=""
                        placeholder="Выберите статус">
                        <template slot="singleLabel" slot-scope="{ option }">
                          {{ option.name }}
                        </template>
                      </multiselect>
                    </div>
                    <div class="col-12">
                      <div class="form-check text-center pb-3">
                        <div>
                          <input
                            type="checkbox" class="form-check-input"
                            id="is-alerted" v-model="inputs.is_alerted">
                            <label class="pl-3 form-check-label" for="is-alerted">
                              Подписка ALERTED
                            </label>
                        </div>
                        <div v-if="!this.subscriptionId">
                          <input
                            type="checkbox" class="form-check-input"
                            id="gift-month" v-model="inputs.gift_month">
                          <label class="pl-3 form-check-label" for="gift-month">
                            Первый месяц в подарок
                          </label>
                        </div>
                        <div v-if="this.subscriptionId">
                          <input
                            @click="suspendedDescriptionSet"
                            type="checkbox" class="form-check-input"
                            id="is-suspended" v-model="suspendedDescriptionShow">
                          <label class="pl-3 form-check-label">
                            Остановить исходящие платежи
                          </label>
                        </div>
                        <div v-if="this.subscriptionId">
                          <input
                            @click="blockedDescriptionSet"
                            type="checkbox" class="form-check-input"
                            id="is-blocked" v-model="inputs.is_provider_disabled">
                          <label class="pl-3 form-check-label">
                            Заблокировать у оператора
                          </label>
                        </div>
                      </div>
                    </div>
                     <div class="col-6 pb-3" v-if="!this.subscriptionId">
                      <div class="form-group">
                        <input v-mask="['#####', '#####']" class="form-control"
                                 required id="amount" v-model="inputs.initial_payment_amount"
                                 @focusin="InputFocusIn('amount')"
                                 @focusout="InputFocusOut('amount')"/>
                        <label for="amount">Начальный платеж</label>
                      </div>
                    </div>
                    <div class="col-6 pb-3 pt-2" v-if="!this.subscriptionId">
                       <div class="select-wrapper">
                         <select v-model="inputs.start_day">
                           <option value="">Дата начала подписки</option>
                           <option v-for="day in days"
                                    :key="day"
                                    :value=day>
                              {{ day }}
                           </option>
                         </select>
                       </div>
                    </div>
                    <div class="col-12" v-if="suspendedDescriptionShow">
                      <datepicker v-model="inputs.suspended_until"
                                  placeholder="Остановить до"
                        :language="ru" @input="inputs.suspended_until = fixDateToFilter($event)"
                        input-class="form-control" id="issue" wrapper-class="form-group" />
                    </div>

                    <div class="col-12" v-if="suspendedDescriptionShow">
                      <textarea id="suspendedDescription" rows="3" class="p-3"
                                v-model="inputs.suspended_description"
                                placeholder='Обязательный комментарий для приостановки платежей'>
                      </textarea>
                    </div>

                    <div class="col-12" v-if="blockedDescriptionShow">
                      <textarea name="blocked-description" rows="3" class="p-3"
                                v-model="inputs.blocked_description"
                                placeholder='Обязательный комментарий для блокировки подписки'>
                      </textarea>
                    </div>

                  </div>
                </div>
              </div>
              <div class="row pt-4">
                <div class="col">
                  <button v-if="this.subscriptionId"
                           type="submit" class="btn btn-primary">Обновить данные</button>
                  <button v-else type="submit" class="btn btn-primary">Добавить</button>
                </div>
              </div>
            </form>
          </slot>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { ru } from 'vuejs-datepicker/dist/locale';
import Multiselect from 'vue-multiselect';
import subscriptionAPI from '../../api/subscription';


export default {
  name: 'v-subscription-create-update-form',
  components: { Multiselect },
  props: ['subscriptionId', 'statusList'],
  data() {
    return {
      suspendedDescriptionShow: false,
      blockedDescriptionShow: false,
      ru,
      status: '',
      inputs: {
        sim_card: '',
        subscriber: '',
        is_alerted: false,
        tariff: '',
        internal_comment: '',
        suspended_until: false,
        initial_payment_amount: '',
        start_day: '',
        suspended_description: '',
        blocked_description: '',
        is_provider_disabled: false,
        gift_month: false,
      },
      days: Array.from(Array(29).keys()),
      loading: true,
    };
  },
  computed: {
    ...mapState('tariff', ['tariffList']),
    ...mapState('simCard', ['simCardList', 'error']),
    ...mapState('user', ['userList', 'error']),
    ...mapState('subscription', ['subscriptionCreateUpdateError']),
  },
  methods: {
    ...mapActions('simCard', ['getSIMCardList']),
    ...mapActions('user', ['getUserList']),
    ...mapActions('tariff', ['getTariffList']),
    ...mapActions('subscription', ['updateSubscription', 'createSubscription']),
    suspendedDescriptionSet() {
      if (this.suspendedDescriptionShow) {
        this.inputs.suspended_until = null;
        this.suspendedDescriptionShow = false;
      } else {
        this.suspendedDescriptionShow = true;
      }
    },
    fullName(obj) {
      return `${obj.last_name} ${obj.first_name} ${obj.middle_name}`;
    },
    gerDealerTariffs() {
      this.inputs.tariff = '';
      this.inputs.initial_payment_amount = '';
      let filter = '?get_all=true';
      if (this.inputs.sim_card.dealer) {
        filter += `&dealer=${this.inputs.sim_card.dealer.id}`;
      }
      if (this.inputs.sim_card.tariff_group) {
        filter += `&tariff_group=${this.inputs.sim_card.tariff_group.id}`;
      }
      this.getTariffList(filter);
    },
    calculatePrice(price, dealerFee, serviceFee) {
      const p = parseFloat(price);
      const df = parseFloat(dealerFee);
      const sf = parseFloat(serviceFee);
      return p + df + sf;
    },
    isCurrentTariff(tariff) {
      return tariff.id === this.inputs.tariff.id;
    },
    initialPaymentCount() {
      const tariff = this.tariffList.find(this.isCurrentTariff);
      this.inputs.initial_payment_amount = this.calculatePrice(tariff.price,
        tariff.dealer_fee, tariff.service_fee);
      this.InputFocusIn('amount');
    },
    close() {
      this.$emit('close');
    },
    blockedDescriptionSet() {
      if (this.blockedDescriptionShow) {
        this.inputs.is_provider_disabled = '';
        this.blockedDescriptionShow = false;
      } else {
        this.blockedDescriptionShow = true;
      }
    },
    createUpdateSubscription() {
      this.inputs.tariff = this.inputs.tariff.id;
      if (this.status.filter === 'is_active') {
        this.inputs.is_active = true;
      }
      if (this.status.filter === 'is_deactivated') {
        this.inputs.is_active = false;
      }
      if (this.status.filter === 'is_paused') {
        delete this.inputs.is_active;
      }
      if (this.subscriptionId) {
        const newData = { subscriptionId: this.subscriptionId, data: this.inputs };
        delete newData.data.sim_card;
        delete newData.data.subscriber;
        delete newData.data.initial_payment_amount;
        delete newData.data.start_day;
        delete newData.data.gift_month;
        if (!this.inputs.suspended_until) {
          newData.data.suspended_until = null;
        }
        if (!this.inputs.suspended_description) {
          delete newData.data.suspended_description;
        }
        if (!this.inputs.blocked_description) {
          delete newData.data.blocked_description;
        }
        this.updateSubscription(newData)
          .then(() => {
            if (!this.subscriptionCreateUpdateError) {
              this.$notify({
                group: 'message',
                title: 'New message:',
                type: 'success',
                text: 'Подписка успешно обновлена!',
              });
            } else {
              this.$notify({
                group: 'message',
                title: 'New message:',
                type: 'error',
                text: 'Произошла ошибка!',
              });
            }
          })
          .finally(() => { this.close(); });
      } else {
        this.inputs.sim_card = this.inputs.sim_card.serial_number;
        this.inputs.subscriber = this.inputs.subscriber.id;
        delete this.inputs.suspended_until;
        delete this.inputs.suspended_description;
        delete this.inputs.blocked_description;
        if (!this.inputs.start_day) {
          this.inputs.start_day = 0;
        }
        this.createSubscription(this.inputs)
          .then(() => {
            if (!this.subscriptionCreateUpdateError) {
              this.$notify({
                group: 'message',
                title: 'New message:',
                type: 'success',
                text: 'Подписка успешно добавлена!',
              });
            } else {
              this.$notify({
                group: 'message',
                title: 'New message:',
                type: 'error',
                text: 'Произошла ошибка!',
              });
            }
          })
          .finally(() => { this.close(); });
      }
    },
  },
  created() {
    this.days.shift();
    this.getTariffList('?get_all=true');
    if (this.subscriptionId) {
      subscriptionAPI.getSubscription(this.subscriptionId)
        .then((response) => {
          if (response.data.suspended_until) {
            this.suspendedDescriptionShow = true;
            this.inputs.suspended_until = response.data.suspended_until;
          }
          if (response.data.is_provider_disabled) {
            this.blockedDescriptionShow = true;
            this.inputs.is_provider_disabled = response.data.is_provider_disabled;
          }
          this.inputs.payment_day = response.data.payment_day;
          this.inputs.tariff = response.data.tariff;
          if (response.data.is_active === true) {
            this.status = { filter: 'is_active', name: 'Активна' };
          } else if (response.data.is_active === false) {
            this.status = { filter: 'is_deactivated', name: 'Неактивна' };
          } else if (response.data.is_active === null) {
            this.status = { filter: 'is_paused', name: 'Приостановлена' };
          }
          this.inputs.is_alerted = response.data.is_alerted;
          this.inputs.internal_comment = response.data.internal_comment;
          this.inputs.sim_card = response.data.sim_card.phone_number;
          this.inputs.subscriber = response.data.subscriber.last_name;
          this.inputs.subscriber += ' ';
          this.inputs.subscriber += response.data.subscriber.first_name;
        })
        .finally(() => { this.loading = false; });
    } else {
      this.status = { filter: 'is_active', name: 'Активна' };
      this.getSIMCardList('?only_new=true&get_all=true');
      this.getUserList('?role=subscriber&get_all=true')
        .finally(() => { this.loading = false; });
    }
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
